import { makeApiRequest } from './api';

export enum EAdminRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MODERATOR = 'moderator',
}

export const normalizeAdminRole = (role: EAdminRole | string): string => {
  return role
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export interface IAdmin {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: EAdminRole;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface AdminAuthResponse {
  admin: IAdmin;
  token: string;
}

export interface ApiResponse<T> {
  status: number;
  success: boolean;
  data?: T;
  message: string;
}

export const adminLogin = async (
  email: string,
  password: string
): Promise<ApiResponse<AdminAuthResponse> | null> => {
  const response = await makeApiRequest<ApiResponse<AdminAuthResponse>>(
    '/auth/admin-login',
    {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }
  );

  return response;
};

export const loadAdminProfile = async (
  token: string,
  refreshAccessToken: () => Promise<string | null>
): Promise<ApiResponse<IAdmin> | null> => {
  const response = await makeApiRequest<ApiResponse<IAdmin>>(
    '/admin-portal/profile',
    {
      token,
      refreshAccessToken,
    }
  );
  return response;
};
